import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ssnInfo: null,
  accountBasicDetails: null,
  selectedCountyForReferral: null,
};

const dataSlice = createSlice({
  name: 'accountInfo',
  initialState,
  reducers: {
    updateSSNData: (state, action) => {
      state.ssnInfo = action.payload;
    },
    updateAccountDetails: (state, action) => {
      state.accountBasicDetails = action.payload;
    },
    updateCountyForReferral: (state, action) => {
      state.selectedCountyForReferral = action.payload;
    },
    clearData: (state) => {
      state.ssnInfo = null;
      state.accountBasicDetails = null;
    },
    clearSelectedCounty: (state) => {
      state.selectedCountyForReferral = null;
    },
  },
});

export const {
  updateAccountDetails,
  updateSSNData,
  updateCountyForReferral,
  clearData,
  clearSelectedCounty,
} = dataSlice.actions;

export const selectSSNData = (state) => state?.accountInfo?.ssnInfo;
export const selectAccountBasicDetails = (state) =>
  state?.accountInfo?.accountBasicDetails;
export const selectreferralCounty = (state) =>
  state?.accountInfo?.selectedCountyForReferral;

export default dataSlice.reducer;
